/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_GuideInputs */



/**
* | output |
* | --- |
* | "User Guide" |
*
* @param {User_GuideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const user_guide = /** @type {((inputs?: User_GuideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_GuideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guide de l’utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerhandbuch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida per l'utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Руководство пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía del usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーガイド")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता गाइड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guia do Usuário")
	return /** @type {LocalizedString} */ ("User Guide")
});